module.exports = AnovaAuthRouting;